import { type SVGProps } from 'react';

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24px"
      height="24px"
      fill="currentcolor"
      aria-hidden="true"
      viewBox="0 0 16 16"
      {...props}
    >
      <path d="M4.14 11.184a.48.48 0 0 0 .68.678l3.179-3.18 3.202 3.203a.48.48 0 0 0 .68-.679L8.677 8.004l3.184-3.185a.48.48 0 1 0-.678-.678L7.998 7.325 4.836 4.162a.48.48 0 1 0-.68.678L7.32 8.004l-3.18 3.18z" />
    </svg>
  );
}
